import { NgModule } from '@angular/core';
import {
  RECAPTCHA_BASE_URL,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module,
  ReCaptchaV3Service,
} from 'ng-recaptcha';
import { BoelsReCaptchaV3Service } from './boels-recaptcha.service';

@NgModule({
  imports: [RecaptchaV3Module],
  providers: [
    BoelsReCaptchaV3Service,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6LeFz44bAAAAAELNGjnyig6sPXILMZZZf9xzRvwr',
    },
    {
      provide: RECAPTCHA_BASE_URL,
      useValue: 'https://recaptcha.net/recaptcha/api.js',
    },
    {
      provide: ReCaptchaV3Service,
      useClass: BoelsReCaptchaV3Service,
    },
  ],
})
export class RecaptchaModule {}
